import styled from "styled-components";
import { displayTime, TimeInterface } from "../../../../interface/Time";
import IconHour from "./IconHour";


const CurrentTime = ({ hours, minutes }: TimeInterface) => {

    return (
        <Container className="box-en-ligne-hour no-border">
            <IconHour />
            <ValueField className="no-border font-hour">
                {displayTime({hours, minutes})}
            </ValueField>
        </Container>
    );
};


const Container = styled.div`
    border: 3px solid;
    border-radius: 5px;
`

const Title = styled.div`
    padding: .5em;
    margin: 0;
`

const ValueField = styled.div`
    font-size: 1.875em;
    border-top: 2px solid;
`



export default CurrentTime;